// utils/axiosInstance.js

import axios from 'axios';

const axiosInstance = axios.create();

let activeRequests = 0;
// We store a global reference to the React setIsLoading function here
let setIsLoadingCallback = () => {};

export const registerLoadingCallback = (callback) => {
  setIsLoadingCallback = callback;
};

// Request Interceptor: Called before a request is sent
axiosInstance.interceptors.request.use(
  (config) => {
    activeRequests += 1;
    if (activeRequests === 1) {
      setIsLoadingCallback(true); // Show loader
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor: Called when a response is received (or error occurs)
const handleResponse = (response) => {
  activeRequests -= 1;
  if (activeRequests === 0) {
    setIsLoadingCallback(false); // Hide loader when all requests finish
  }
  return response;
};

axiosInstance.interceptors.response.use(handleResponse, (error) => {
    handleResponse(error); // Hide loader on error too
    return Promise.reject(error);
});

export default axiosInstance;
